import { all, takeLatest, put, call } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import api from 'services/api';
import { IMedicalCertificate, IMedicalCertificateTypes } from './types';
import { medicalCertificateGetFailure, medicalCertificateGetSuccess } from './actions';

export function* medicalCertificateGetRequest() {
  try {
    const { data }: AxiosResponse<{ data: IMedicalCertificate[] }> = yield call(api.get, '/solicitacoes');

    yield put(medicalCertificateGetSuccess(data.data));
  } catch (error: any) {
    if (error?.response) {
      yield put(
        medicalCertificateGetFailure({
          status: error.response?.status,
          message: error.response?.data?.message,
        }),
      );
      return;
    }

    yield put(
      medicalCertificateGetFailure({
        status: 500,
        message: 'Erro interno de servidor',
      }),
    );
  }
}

export default all([
  takeLatest(IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_REQUEST, medicalCertificateGetRequest),
]);
